/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form data for Direct Dial.
────────────────────────────────────────────────────────────────*/

import type { DirectDialFormState } from '../types';

export function createDefaultFormData(): DirectDialFormState {
  return {
    code: '',
    name: '',
    description: '',
    context: '',
    destinationModule: 'extension',
    destinationValue: '',
    enabled: true
  };
}

